var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"toast-container"},_vm._l((_vm.toasts),function(toast){return _c('toast-notification',{key:toast.id,attrs:{"message":toast.message,"type":toast.type,"duration":toast.duration},on:{"close":function($event){return _vm.removeToast(toast.id)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }